export default __webpack_public_path__ + "static/media/placeholder-3.3a9c5233.png";